import { withRouter } from 'react-router-dom'
import namProcessor from '../processor/namProcessor'
import Crud from '../components/form/Crud'

function Nam() {
  const moduleName = 'năm'
  const processor = namProcessor

  const column = [{ value: 'name', name: 'Tên', sortable: true }]

  const config = {
    fields: ['name'],
    maxLength: { name: 10 },
    col: { name: 12 },
    required: ['name'],
    name: {
      name: 'Tên',
    },
  }

  return (
    <>
      <Crud processor={processor} moduleName={moduleName} column={column} config={config} />
    </>
  )
}

export default withRouter(Nam)
